import Vue from "vue";
import App from "./App.vue";
import router from "../src/router";
import store from "./store";
import Axios from 'axios';
import iView from 'iview';
import 'iview/dist/styles/iview.css';
import './mytheme/index.less';
import './styles/index.less';


Vue.use(iView);
Vue.config.productionTip = false;

// Vue.prototype.$qs = qs;
if (process.env.NODE_ENV === "production") {
  Vue.prototype.uploadUrl = "https://tjltb.tongji.edu.cn:8200/file/upload";//正式环境
  Vue.prototype.imgurl = "http://192.168.165.14/retire";//正式环境
} else {
  Vue.prototype.uploadUrl = "http://192.168.124.2:8200/file/upload";//测试环境
}

var f1 = function CustomMessageInfo(infoText) {
  this.$Modal.info({
    title: "通知",
    content: infoText
  });
}


var f2 = function CustomMessageWarn(infoText) {
  this.$Modal.warning({
    title: "通知",
    content: infoText
  });
}

var f3 = function CustomMessageError(infoText) {
  this.$Modal.error({
    title: "通知",
    content: infoText
  });
}

Vue.prototype.$http = Axios;
Vue.prototype.$CustomMessageInfo = f1;
Vue.prototype.$CustomMessageWarn = f2;
Vue.prototype.$CustomMessageError = f3;
Vue.prototype.bus = new Vue(); // 创建公共挂载点

Axios.defaults.baseURL = '/retireSystem/';
Axios.defaults.withCredentials = false;
Axios.defaults.timeout = 10000;

// 请求拦截器
Axios.interceptors.request.use(function (config) {
  // debugger
  var token = sessionStorage.getItem('token_retire_school');
  if (token) {
    // config.headers.Authorization = token; //请求头部添加token
    config.headers.token = token; //请求头部添加token
  }
  if (config.method == 'get') {
    config.params = {
      ...config.params,
      _t: Date.parse(new Date()) / 1000
    }
  }
  return config;
}, function (error) {
  return Promise.reject(error);
});

//响应拦截
Axios.interceptors.response.use((response) => {
  if (response) {
    switch (response.data.status) {
      case 2007:
        sessionStorage.removeItem('token_retire_school');
      //  Message.error('无访问权限，请先登录')
      // router.replace({path:'/login',query: {redirect: router.currentRoute.fullPath}})
    }

  }
  return response;

}, function (error) {
  if (error.response) {
    switch (error.response.status) {
      case 401:
        // 返回401 清除token信息并跳转到登陆页面
        sessionStorage.removeItem('token_retire_school');
        // router.replace({ path: '/login', query: {  redirect: router.currentRoute.fullPath  } });
        //Message.error('无访问权限，请先登录')
        break
      case 404:
        //Message.error('网络请求不存在')
        break
      default:
        //Message.error(error.response.data.message)
    }
  } else {
    // 请求超时或网络有问题
    if (error.message.includes('timeout')) {
      //Message.error('请求超时！请检查网络是否正常')
    } else {
      //Message.error('请求失败，请检查网络是否已连接')
    }
  }
  return Promise.reject(error);
});

// get，post请求方法
export default {
  post(url, data) {
    return $http({
      method: 'post',
      url,
      data: Qs.stringify(data),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      }
    })
  },
  get(url, params) {
    return $http({
      method: 'get',
      url,
      params
    })
  },

}


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
